import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getJustificationHistory } from "./index";

export const useGetJustificationHistory = (
  date: string,
  processDefinitionId: number,
  enabled = true
) => {
  const customFetch = useClientContext();

  return useQuery({
    queryKey: ["justification-history", date, processDefinitionId],
    queryFn: () =>
      getJustificationHistory(customFetch)(date, processDefinitionId),
    enabled: enabled && Boolean(date) && processDefinitionId > 0,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
